module.exports = __webpack_public_path__ + "img/3.3.6ac4d258.png";